import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreFollowedAllSlice } from './get';

export const coreFollowedAllReducers = combineReducers({
	get: getCoreFollowedAllSlice.asyncReducers
});

export const coreFollowedAllWatchers = combineAllWatchers([
	getCoreFollowedAllSlice.asyncWatchers
]);
